class AppVersionUpdateModalController {
  constructor($scope, $uibModalInstance, AppVersionService, message, title) {
    "ngInject";
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.AppVersionService = AppVersionService;
    this._message = message;
    this._title = title;
  }

  get shouldShowAndroidUpdateMessage() {
    return this.AppVersionService && this.AppVersionService.isAndroidCordova;
  }
  get shouldShowIOSUpdateMessage() {
    return this.AppVersionService && this.AppVersionService.isIOSCordvoa;
  }

  confirm() {
    if (this.AppVersionService.isIOS) {
      this.AppVersionService.openIOSDownloadPage();
    }
    this.$uibModalInstance.close();
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  get message() {
    return this._message;
  }

  get title() {
    return this._title;
  }
}

export default AppVersionUpdateModalController;
